module.exports = __webpack_public_path__ + "img/toEmail.7a4e0b6e.png";